import styled from 'styled-components';
import { Typography } from '../Typography/Typography.styled';

export const Title = styled(Typography.Title)`
  && {
    color: ${({ color }) => color};
    font-weight: bold;
    font-size: ${({ theme }) => `${20 + 2 * theme.zoomFonte}px`};
    /* Superfície opaca — axe ignora text-shadow no color-contrast */
    display: block;
    width: fit-content;
    max-width: 100%;
    padding: 4px 8px;
    margin-left: -8px;
    margin-bottom: 12px;
    border-radius: 4px;
    background-color: #f5f5f5;
  }
`;
